// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"500":"6f34d31c","755":"6f34d31c","863":"1caf2fd0","958":"6f34d31c"}[chunkId] + ".chunk.css";
};